// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brandlogo{color:#fff!important;text-decoration:none;font-size:18px!important}.avatarText{font-size:20px!important;font-weight:500;line-height:32px!important;letter-spacing:normal!important}.badge-font-size{font-size:9px}.v-app-bar-title__content{width:200px}", ""]);
// Exports
module.exports = exports;
